// extracted by mini-css-extract-plugin
export var drawerPaper = "_3e-0";
export var itemCard = "_3e-1";
export var itemImage = "_3e-2";